<template>
  <div>
    <!-- modal -->
    <b-modal
      v-model="showcode"
      id="modal-multi-2"
      title="แก้ไขโคด"
      ok-only
      ok-title="Exit"
    >
      <b-form-input id="code" v-model="code" type="text" placeholder="code" />
      <b-alert v-if="check.code == true" variant="danger" show>
        <span>Please Enter</span>
      </b-alert>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1"
        @click="update()"
      >
        Update
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, VBModal, BFormInput, BAlert } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import "animate.css";
import Swal from "sweetalert2";
import api from "@/api";
export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BFormInput,
    BAlert,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      code_id: null,
      code: null,
      code_status: null,
      showcode: null,
      check: {
        code: false,
      },
    };
  },
  mounted() {},
  created() {},
  computed: {},
  methods: {
    refresh(id) {
      this.$emit("showModaledit", "showModaledit");
      console.log('refresh')
    },
    async showModalcode(id) {
      console.log("id", id);
      this.code_id = id;
      const params = {
        id: id,
      };
      api.post("/editcode", params).then((response) => {
        console.log(response.data);
        for (let item of response.data.data) {
          (this.code = item.code), (this.code_status = item.code_status);
        }
      });
      this.showcode = true;
    },

    update() {
      if (this.code) {
        Swal.fire({
          title: "ยืนยันการแก้ไขข้อมูล",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
          preConfirm: () => {},
        }).then((result) => {
          if (result.isConfirmed) {
            let formData = new FormData();
            formData.append("code_id", this.code_id);
            formData.append("code", this.code);
            console.log(this.code);
            api
              .post("/updatecode", formData)
              .then((response) => {
                console.log("response", response.data);
                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "success",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.showcode = false;
                  this. refresh();
                }
              })
              .catch((error) => {
                console.log(error.response);
              });
          }
        });
      } else {
        if (!this.code) {
          this.check.code = true;
          console.log("code null");
        }
      }
    },
  },
  setup() {},
};
</script>
